import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class CommonService {

  private _baseUrl = './api/common';

  constructor(private _http: HttpClient) { }


  version(): Observable<string> {

    return this._http.get<string>(this._baseUrl + '/version');

  }

  staging(): Observable<boolean> {

    return this._http.get<boolean>(this._baseUrl + '/staging');

  }

  signout(): Observable<string> {

    return this._http.get<string>(this._baseUrl + '/signout');
  }

  baseUrl(): Observable<string> {

    return this._http.get<string>(this._baseUrl + '/baseUrl');
  }

  baseSite(): Observable<string> {

    return this._http.get<string>(this._baseUrl + '/baseSite');
  }


  name(): Observable<string> {

    return this._http.get<string>(this._baseUrl + '/name')
      .pipe(
        map(resp => resp)
      );
  }

  emailAddress(): Observable<string> {
    return this._http.get<string>(this._baseUrl + "/UserEmail");
  }
}
